// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"48":"7db5f895","371":"cfa2cb3b","374":"02d0a394","488":"37335826","526":"12b2dd05","836":"3d499fd6","913":"54fbb82c"}[chunkId] + ".css";
};